import React from 'react';
import { BrandWrapperV2 } from 'components';
import { AcceptMembershipInvitePage } from './components';
const AcceptMembershipInvite = () => (React.createElement(BrandWrapperV2, null,
    React.createElement(AcceptMembershipInvitePage, null)));
export default AcceptMembershipInvite;
